import { api } from "@/boot/axios"
import { getAuthToken } from "@/boot/axios"
import { type Ecosystem, type Partner, type Material, Interest, MaritalStatus, Industry } from "@/interfaces"

export function useReference() {

  const getEcosystemList = async () => {
    try {
      const response = await api.get<Ecosystem[]>('/ecosystem/list', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er: any) {
      console.error(er)
      return er
    }
  }

  const getPartnersList = async () => {
    try {
      const response = await api.get<Partner[]>('/partner/list', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er: any) {
      console.error(er)
      return er
    }
  }

  const getPartnerDetail = async (partnerId: number) => {
    try {
      const response = await api.get<Partner>(`/partner/${partnerId}`, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return undefined
    }
  }

  const getMaterialList = async () => {
    try {
      const response = await api.get<Material[]>('/material/list', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er: any) {
      console.error(er)
      return er
    }
  }

  const getInterestList = async () => {
    try {
      const response = await api.get<Interest[]>('/interest/list', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return []
    }
  }

  const getMaritalStatuses = async () => {
    try {
      const response = await api.get<MaritalStatus[]>('/marital/list', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return []
    }
  }

  const getIndustryList = async () => {
    try {
      const response = await api.get<Industry[]>('/industry/list', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return []
    }
  }

  return {
    getEcosystemList,
    getPartnersList,
    getPartnerDetail,
    getMaterialList,
    getInterestList,
    getMaritalStatuses,
    getIndustryList
  }
}